import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import ClaimStatusBadge from "../../components/ClaimStatusBadge";
import Pagination from "../../components/Pagination";
import SkeletonCardLoad from "../../components/SkeletonCardLoad";
import { Claim, ClaimStatus } from "../../models/Claim";
import { PageableCollection } from "../../models/PageableCollection";
import authRestClient from "../../services/clients/AuthRestClient";

const TravelClaims = () => {

    const iconStyle = {
        fontSize: "1rem"
    }

    /** Init model for claims collection */
    let collectionInit: PageableCollection<Claim> = {
        totalPages : 0,
        count      : 0,
        next       : "",
        previous   : "",
        results    : []
    }

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [claims, setClaims] = React.useState<PageableCollection<Claim>>(collectionInit);

    async function onPaginationChange(page: number) {
        /* Fetch data for the current logged in user and page number */
        authRestClient.get<PageableCollection<Claim>>("/api/travelclaim?page=" + page)
            .then(response => {
                if (response.status === 200) {
                    /* Status OK */
                    setClaims(response.data);
                }
                else if (response.status === 204) {
                    /* Status NoContent */
                    setClaims(collectionInit);
                }
            })
            .catch(error => {
            });
    }

    useEffect(() => {
        setIsLoading(true);
        /* Fetch data for the current logged in user */
        authRestClient.get<PageableCollection<Claim>>("/api/travelclaim")
            .then(response => {
                if (response.status === 200)
                {
                    /* Status OK */
                    setClaims(response.data);
                }
                else if (response.status === 204)
                {
                    /* Status NoContent */
                    setClaims(collectionInit);
                }
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            });
    }, [])

    return (
        <main className="container">

            <div className="row text-center">
                <div className="col-12">
                    <img src="/brand.png" alt="brand" className="brand" />
                </div>
            </div>

            <div className="row text-center">
                <div className="col-12">
                    <h2>Your Travel Claim Forms</h2>
                </div>
                <div className="col-12">
                    <p>Overview of Unit Costs Claim Forms saved by you.</p>
                </div>
            </div>

            <div className="row mb-3">

                <div className="col-12">
                    <Pagination onPageChange={onPaginationChange} next={claims.next} previous={claims.previous} count={claims.count} totalPages={claims.totalPages} />
                </div>

                <div className="col-12">
                    {
                        isLoading ? <SkeletonCardLoad cardsCount={3} />
                                  :
                        claims.results.map((value, index) => {
                            return (
                                <div className="col-12" key={value.guid}>
                                    <div className="card mb-2">
                                        <div className="row g-0">

                                            <div className="col-12 col-md-9">
                                                <div className="card-body">

                                                    <div className="row">
                                                        <div className="col-12">
                                                            <ClaimStatusBadge status={value.status} />
                                                        </div>
                                                    </div>

                                                    <hr />

                                                    <dl className="row mb-1">
                                                        <dt className="col-md-12">
                                                            <label><i className="bi bi-calendar me-2"></i>Seminar</label>
                                                        </dt>
                                                        <dd className="col-md-12">
                                                            {value.event.title}
                                                        </dd>
                                                    </dl>

                                                    <dl className="row mb-1">
                                                        <dt className="col-md-12">
                                                            <label><i className="bi bi-person me-2"></i>Participant</label>
                                                        </dt>
                                                        <dd className="col-md-12">
                                                            {value.lastname + ", " + value.firstname}
                                                        </dd>
                                                    </dl>

                                                    <dl className="row mb-1">
                                                        <dt className="col-md-12">
                                                            <label><i className="bi bi-envelope me-2"></i>Email</label>
                                                        </dt>
                                                        <dd className="col-12">
                                                            <Link to="/#">{value.email}</Link>
                                                        </dd>
                                                    </dl>

                                                    <dl className="row mb-1">
                                                        <dt className="col-md-12">
                                                            <label><i className="bi bi-arrow-right me-2"></i>Your place of employment</label>
                                                        </dt>
                                                        <dd className="col-md-12">
                                                            {value.institution.name} - {value.institution.address.street} - {value.institution.address.city}
                                                        </dd>
                                                    </dl>

                                                    <dl className="row mb-1">
                                                        <dt className="col-md-12">
                                                            <label><i className="bi bi-arrow-left me-2"></i>Event Location</label>
                                                        </dt>
                                                        <dd className="col-md-12">
                                                            {value.event.location}
                                                        </dd>
                                                    </dl>

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3 bg-light p-2 d-flex flex-column justify-content-start">

                                                <div className="row mb-1">
                                                    <div className="col-12">
                                                        <Tooltip id="travelCostTTip" />
                                                        <span className="badge bg-dark badge-lg p-2" data-tooltip-id="travelCostTTip" data-tooltip-content={"Distance travelled by " + (value.calculatedTravelCosts?.travelType === 0 ? "airplane" : "land transport")} data-tooltip-place="bottom">
                                                            <i style={iconStyle} className={value.calculatedTravelCosts?.travelType === 0 ? "bi bi-airplane me-2" : "bi bi-train-front me-2"}></i>
                                                            {Math.round(value.calculatedTravelCosts?.distance ?? 0)} km
                                                        </span>

                                                        {value.calculatedAccommodationCosts &&
                                                            <>
                                                                <Tooltip id="accommodationCostTTip" />
                                                                <span className="badge bg-dark badge-lg ms-2 p-2" data-tooltip-id="accommodationCostTTip" data-tooltip-content="Nights spent" data-tooltip-place="bottom">
                                                                    <i style={iconStyle} className="bi bi-house me-2"></i>
                                                                    {value.calculatedAccommodationCosts?.nights}
                                                                </span>
                                                            </>
                                                        }
                                                    </div>
                                                </div>

                                                <hr />

                                                <div className="row align-self-strech mb-auto mt-auto">
                                                    <div className="col-12 mb-2 text-center">
                                                        <Tooltip id="reimbursementTTip" />
                                                        <label className="display-4 fw-bold" data-tooltip-id="reimbursementTTip" data-tooltip-content="Total Reimbursement">&euro; {(value.calculatedTravelCosts?.amount ?? 0) + (value.calculatedAccommodationCosts?.totalAmount ?? 0)}</label>
                                                    </div>
                                                </div>

                                                <hr />

                                                <div className="row mb-0">
                                                    <div className="col-12">
                                                        <Link to={"/me/claims/" + value.guid} className="btn btn-warning w-100"><i className="bi bi-eye me-1"></i>Details</Link>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>

            </div>

        </main>
    );
}
export default TravelClaims;